/**
 * 5度电 视频版块
 */
export default class FiveKwhVideo {
	constructor(index, type) {
		this.index = index;
		this.type = type;
		this.init();
	}

	init() {
		const self = this;

		if ($(`.five-kwh-video .play-button-${self.index}`).length > 0) {
			$(`#five-kwh-video-${self.index} .jky-video-poster_button`).hide();
			$(`.five-kwh-video .play-button-${self.index}`).click(function () {
				$(`#five-kwh-video-${self.index} .jky-video-poster_container`).click();  // 触发按钮的点击事件
				$(`.five-kwh-video .play-button-${self.index}`).hide();
			});
		}
		//出现小封面页隐藏播放按钮
		if ($(`.five-kwh-video .mini-img-${self.index}`).length > 0) {
			$(`#five-kwh-video-${self.index} .jky-video-poster_button`).hide();
		}

		const button = $(`.five-kwh-video .button-box-${self.index}`);
		button.on('click', function () {
			$(`.five-kwh-video .more-box-${self.index}`).addClass('open');
		});


		// 进场动效，仅PC端+通屏模式+开关打开后生效
		const currId = `#five-kwh-video-${self.index}`;
		const switchFlag = $(currId).data('switch');
		if (window.innerWidth > 1023 && self.type === 'full' && switchFlag) {
			let startTop;

			// Header高度获取
			let headerH = document.querySelector('jky-header,header-v5,.site-header').offsetHeight;
			if ($('.header-after-sales').length > 0) {
				headerH = headerH + $('.header-after-sales').height();
			}

			if ($('.product-tabs-box,.section-navigation').length > 0) {
				startTop = $('.product-tabs-box,.section-navigation').height();
			} else {
				startTop = headerH;
			}

			const centerTopVal = (window.innerHeight - $(currId).height()) / 2;
			let startVal;
			if (centerTopVal < startTop) {
				startVal = `top ${startTop}`;
			} else {
				startVal = `top ${centerTopVal}`;
			}

			let tl;
			const time = tl ? tl.time() : 0;
			if (tl) {
				tl.kill();
			}
			tl = window.gsap.timeline({
				scrollTrigger: {
					trigger: currId,
					pin: true, // 将触发元素固定，在激活时
					start: startVal, // 当触发元素的顶部碰到xxx时
					end: `+=100%`, // 滚动 xxx 后结束
					scrub: 1, // 平滑擦洗，需要 1秒钟来“赶上”滚动条
					// markers: true,
					ease: "none"
				}
			});

			const innerAnimationImgClass = `#entry-img-box-inner-${self.index}`;
			const outterAnimationImgClass = `#entry-img-box-outter-${self.index}`;
			tl.addLabel('start')
				.addLabel('show outter img box')
				.to(outterAnimationImgClass, {
					opacity: 1,
					duration: 0.01,
					ease: "power1.inOut",
				})
				.to(outterAnimationImgClass, {
					display: 'block',
					duration: 0,
				})
				.addLabel('hide inner img box')
				.to(innerAnimationImgClass, {
					opacity: 0,
					duration: 0.01,
					ease: "power1.inOut",
				})
				.to(innerAnimationImgClass, {
					display: 'none',
					duration: 0
				})
				.addLabel('animate outter img box')
				.to(outterAnimationImgClass, {
					transform: 'scale(8)',
					ease: "none",
					duration: 8
				})
				.to(outterAnimationImgClass, {
					opacity: 0,
					duration: 2,
					ease: "power1.inOut",
				})
				.to(outterAnimationImgClass, {
					display: 'none',
					duration: 0,
				})
				.addLabel('end')

			tl.time(time);
		}
	}
}


